export default function camelizeAttribute(attr) {
  return attr.toLocaleLowerCase().replace(/-(.)/g, (match, letter) => letter.toUpperCase());
}
